import { VertexData } from '@babylonjs/core/Meshes/mesh.vertexData';
import { SmplAvatarBuilder } from '@seddi/avatar-builder';
import type { SmplMeshDesc, VertexDataDesc } from './meshTypes';

/**
 * Empty vertex data.
 */
export function createEmptyVertexDataDesc(): VertexDataDesc {
  return {
    indices: new Uint32Array(0),
    normals: new Float32Array(0),
    positions: new Float32Array(0),
    uvs: new Float32Array(0),
  };
}

/**
 * Build vertex data descriptor.
 * @param desc - SMPL shape descriptor.
 */
export function buildVertexDataDesc(desc: SmplMeshDesc): VertexDataDesc {
  const builder = new SmplAvatarBuilder(desc, true);
  const mesh = builder.buildAll(desc.pose, { withNormals: true, withUvs: true });
  return mesh.geometry as VertexDataDesc;
}

/**
 * Build vertex data.
 * @param desc - SMPL shape descriptor.
 */
export function buildVertexData(desc: SmplMeshDesc): VertexData {
  const dataDesc = buildVertexDataDesc(desc);
  const data = new VertexData();
  data.indices = dataDesc.indices;
  data.positions = dataDesc.positions;
  data.normals = dataDesc.normals;
  data.uvs = dataDesc.uvs;
  return data;
}
